
import Vue from 'vue';
import { TransformedCmCopy } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedCmCopy['data'],
      required: true,
    },
  },
  mounted() {
    setTimeout(() => {
      this.deleteEmptyPtags();
    }, 500);
  },
  methods: {
    deleteEmptyPtags() {
      const copyRight = this.$el.querySelector<HTMLElement>('.cm-copy__right');
      if (copyRight && copyRight.childNodes.length > 1) {
        const copyRightLastElement = copyRight.childNodes[copyRight.childNodes.length - 1] as HTMLElement;
        const copyRightBeforeLastElement = copyRight.childNodes[copyRight.childNodes.length - 2] as HTMLElement;
        if (this.isEmpty(copyRightLastElement.innerHTML) && copyRightBeforeLastElement) {
          copyRightLastElement.innerHTML = '';
          copyRightBeforeLastElement.style.marginBottom = '0';
        }
      }
      const copyLeft = this.$el.querySelector<HTMLElement>('.cm-copy__left');
      if (copyLeft && copyLeft.childNodes.length > 1) {
        const copyLeftLastElement = copyLeft.childNodes[copyLeft.childNodes.length - 1] as HTMLElement;
        const copyLeftBeforeLastElement = copyLeft.childNodes[copyLeft.childNodes.length - 2] as HTMLElement;
        if (this.isEmpty(copyLeftLastElement.innerHTML) && copyLeftBeforeLastElement) {
          copyLeftLastElement.innerHTML = '';
          copyLeftBeforeLastElement.style.marginBottom = '0';
        }
      }
    },

    isEmpty(inner: string) {
      return inner.replaceAll(/(<br>)/gi, '') === '';
    },
  },
});
